import { VISIT_EVENT_TYPES } from 'src/consumer/constants'
import { getPriceStringWithCurrency } from 'src/mentor/helpers/utilityFunctions'

function getFilteredSlotsByClinicId(bookedSlots, clinicId) {
  return bookedSlots?.filter((slot) => slot?.clinicId === clinicId)
}

export function getFilteredBookedSlotsByVisitEventType(bookedSlots, type, clinicId) {
  let events = bookedSlots?.filter((slot) => {
    return slot?.status === 'booked' && slot?.paymentStatus === 'paid'
  })

  if (!!type) {
    events = events?.filter((slot) => {
      return slot?.visitEventType === type
    })
  }

  if (clinicId) {
    events = getFilteredSlotsByClinicId(events, clinicId)
  }
  return events
}

export function getFeeCollectedFromBookedSlotsWithCurrencyString(bookedSlots) {
  let sum = 0
  let firstFoundCurrency = 'inr'

  for (let a in bookedSlots) {
    sum += bookedSlots[a].feePaid || 0
  }


  return getPriceStringWithCurrency(sum, firstFoundCurrency)
}
